import { type FunctionComponent, useContext } from 'react';
import { SHOP_BY_LOOK_LINK } from '../../constants/links';
import { QuickStartContext } from '../../contexts/quickstart/quickstart.context';
import { Link } from '../common-components/link/link.component';
import { QuickStartReactionButton } from '../quick-start-reaction-button/quick-start-reaction-button.component';

export type QuickStartShowcaseFavoriteButtonProps = {
	quickStartId: number;
	isShopByLook?: boolean;
};

export const QuickStartShowcaseFavoriteButton: FunctionComponent<QuickStartShowcaseFavoriteButtonProps> = ({
	quickStartId,
	isShopByLook = false
}) => {
	const { favoritedQuickStarts } = useContext(QuickStartContext);

	if (favoritedQuickStarts.includes(quickStartId) && !isShopByLook) {
		return (
			<div className={`absolute top-1 right-0 bg-theme-white pv2 ph5 flex flex-row br2 br--left items-center fade-in`}>
				<div className="pr2">
					<Link url={`${SHOP_BY_LOOK_LINK}?favorites=true`} underline={true}>
						Go to Favorites
					</Link>
				</div>
				<QuickStartReactionButton quickStartId={quickStartId} />
			</div>
		);
	}
	return (
		<div className="absolute top-0 right-0 pt2 pr2">
			<QuickStartReactionButton quickStartId={quickStartId} isShopByLook={isShopByLook} />
		</div>
	);
};
